import button from '../button/button'
import spacer from '../spacer/spacer'
import languages from '../languages/languages'

import menuOld from '../menuOld/menu'

export default function(o, noLogo, noInfoSlash){

  var lang = o.store('lang')

  var infoUrls = [
    '/info',
    '/sponsors',
    '/licence',
    '/press',
    '/news',
    '/contact',
    '/login',
  ]

  var isSubmenuPage = _.includes(infoUrls,location.pathname)

  var click = function(url, isLogo, isInfo){
    if(isLogo){
      return function(){
        history.pushState({}, '', '/')
        o.render(o)
      }  
    } else if (isInfo){
      if(isSubmenuPage){
        return false
      } else {
        return function(){
          history.pushState({}, '', '/info')
          o.render(o)
        }  
      }
    } else {
      if(_.includes(location.pathname, url)){
        return false
      } else {
        return function(){
          history.pushState({}, '', url)
          o.render(o)
        }
      }  
    }
  }

  var antiArchiveLabel = o.util.getTranslation(o, 'antiArchive')
  var archiveLabel = o.util.getTranslation(o, 'archive')
  var storiesLabel = o.util.getTranslation(o, 'stories')

  var infoLabel = o.util.getTranslation(o, 'info')
  var factsLabel = o.util.getTranslation(o, 'facts')
  var sponsorsLabel = o.util.getTranslation(o, 'sponsors')
  var licenceLabel = o.util.getTranslation(o, 'licence')
  var pressLabel = o.util.getTranslation(o, 'press')
  var newsLabel = o.util.getTranslation(o, 'news')
  var contactLabel = o.util.getTranslation(o, 'contact')
  var loginLabel = o.util.getTranslation(o, 'login')

  var buttonsDiv = $('<div>')
  $('<div>')
  .css({
    padding: '0',
  })

  if(!noLogo){
    buttonsDiv
    .append(
      button(o, 'open memory box', click(null, true))
      .css({
        marginLeft: '0.5rem',
      }),
      spacer(o),
    )
  }

  buttonsDiv
  .append([
    button(o, antiArchiveLabel, click('/anti-archive')),
    button(o, archiveLabel, click('/archive')),
    button(o, storiesLabel, click('/stories')),
  ])


  if(!noInfoSlash){
    buttonsDiv
    .append([
      spacer(o),
    ])
  }

  buttonsDiv
  .append([
    button(o, infoLabel, click('/info', false, true)),
  ])

  var menuDiv =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: o.fontSizeDef.s,
    })
    .append(buttonsDiv)

  var submenuDiv =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      marginTop: '-0.6rem',
      fontSize: o.fontSizeDef.s,
    })
    .append(

      $('<div>')
      .css({
        padding: '0',
      })
      .append([

        button(o, factsLabel, click('/info')),
        button(o, sponsorsLabel, click('/sponsors')),
        button(o, pressLabel, click('/press')),
        button(o, newsLabel, click('/news')),
        button(o, contactLabel, click('/contact')),
        button(o, licenceLabel, click('/licence')),
        button(o, loginLabel, click('/login')),

      ])

    )

  var div = $('<div>')
  .css({
    padding: "0.8rem",
  })
  .append([
    menuDiv,
  ])

  if(isSubmenuPage){
    div.append([
      submenuDiv,
    ])
  }

  if(!o.isTouch){
    div.mousemove(function(e){
      div.scrollLeft(
        e.pageX / div.width() * (div[0].scrollWidth - div.width()) + 20
      )
    })
  }

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/menu/menu.js